import { Box, Typography } from '@mui/material';
import { UNIT_SYSTEM } from '../../../../shared/config/hydraulics_constants';
import { DATAGRID_TABLE_CELL_WIDTH } from '../../../../utils/constants';

const columns = (renderValueCell, renderModelCell, hydraulicsUnit, currentUnit, properties, dialogParameter, hydraulicParameterData) => {
  const hideEQLosses = properties.some(row => Number(row.flow_in || 0) !== 0);

  const hideROP = hydraulicParameterData.some(item => item.parameter === 'ROP');
  const hideRPM = hydraulicParameterData.some(item => item.parameter === 'RPM');
  const hideHoleDepth = hydraulicParameterData.some(item => item.parameter === 'Hole Depth');
  const hideFlowRate = hydraulicParameterData.some(item => item.parameter === 'Flow Rate');

  return [
    {
      field: 'rheo_model',
      headerName: 'Model',
      renderHeader: () => (
      <Box>
      <Typography sx={{ fontSize: '1.2rem' }}>
      Model
      </Typography>
      </Box>
      ),
      flex: 1,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 10,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderEditCell: renderModelCell,
      editable: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'hole_depth',
      headerName: `Hole Depth (${hydraulicsUnit?.hole_depth?.label})`,
      renderHeader: () => (
      <Box>
      <Typography sx={{ fontSize: '1.2rem' }}>
      Hole
      </Typography>
      <Typography sx={{ fontSize: '1.2rem' }}>
        Depth ({hydraulicsUnit?.hole_depth?.label})
      </Typography>
      </Box>
      ),
      flex: 1,
      hide: hideHoleDepth,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 10,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderEditCell: renderValueCell,
      editable: true,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => {
        if (params.value === null || params.value === undefined || params.value === '') {
          return '';
        }
        const value = Number(params.value);
        if (isNaN(value)) {
          return params.value;
        }
        return currentUnit !== UNIT_SYSTEM.US ? value : parseFloat(value.toFixed(hydraulicsUnit?.hole_depth?.decimals));
      },
    },
    {
      field: 'bit_depth',
      headerName: `Bit Depth (${hydraulicsUnit?.bit_depth?.label})`,
      renderHeader: () => (
      <Box>
      <Typography sx={{ fontSize: '1.2rem' }}>
        Bit
      </Typography>
      <Typography sx={{ fontSize: '1.2rem' }}>
        Depth ({hydraulicsUnit?.bit_depth.label})
      </Typography>
      </Box>
      ),
      flex: 1,
      hide: dialogParameter === 'stripping' || hideHoleDepth,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH + 40,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderEditCell: renderValueCell,
      editable: true,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => {
        if (params.value === null || params.value === undefined || params.value === '') {
          return '';
        }
        const value = Number(params.value);
        if (isNaN(value)) {
          return params.value;
        }
        return currentUnit !== UNIT_SYSTEM.US ? value : parseFloat(value.toFixed(hydraulicsUnit?.bit_depth.decimals));
      },
    },
    {
      field: 'bit_depth_offset',
      headerName: `Bit Depth Offset (${hydraulicsUnit?.bit_depth_offset?.label})`,
      renderHeader: () => (
        <Box>
        <Typography sx={{ fontSize: '1.2rem' }}>
        Bit Depth
        </Typography>
        <Typography sx={{ fontSize: '1.2rem' }}>
          Offset ({hydraulicsUnit?.bit_depth_offset?.label})
        </Typography>
        </Box>
      ),
      flex: 1,
      hide: !hideHoleDepth,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderEditCell: renderValueCell,
      headerAlign: 'center',
      align: 'center',
      valueFormatter: (params) => {
        if (params.value === null || params.value === undefined || params.value === '') {
          return '';
        }
        const value = Number(params.value);
        if (isNaN(value)) {
          return params.value;
        }
        return currentUnit !== UNIT_SYSTEM.US ? value : value.toFixed(hydraulicsUnit?.bit_depth_offset?.decimals);
      },
    },
    {
      field: 'rop',
      headerName: `ROP (${hydraulicsUnit?.rop?.label})`,
      flex: 1,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 20,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderEditCell: renderValueCell,
      editable: true,
      hide: dialogParameter === 'rollover' || dialogParameter === 'stripping' || hideROP || dialogParameter === 'displacement',
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => {
        if (params.value === null || params.value === undefined || params.value === '') {
          return '';
        }
        const value = Number(params.value);
        if (isNaN(value)) {
          return params.value;
        }
        return currentUnit !== UNIT_SYSTEM.US ? value : parseFloat(value.toFixed(hydraulicsUnit?.rop?.decimals));
      },
    },
    {
      field: 'rpm',
      headerName: `RPM (${hydraulicsUnit?.rpm?.label})`,
      flex: 1,
      hide: hideRPM,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 10,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderEditCell: renderValueCell,
      editable: true,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => {
        if (params.value === null || params.value === undefined || params.value === '') {
          return '';
        }
        const value = Number(params.value);
        if (isNaN(value)) {
          return params.value;
        }
        return currentUnit !== UNIT_SYSTEM.US ? value : parseFloat(value.toFixed(hydraulicsUnit?.rpm?.decimals));
      },
    },
    {
      field: 'flow_in',
      headerName: `Flow Rate (${hydraulicsUnit?.flow_in?.label})`,
      renderHeader: () => (
      <Box>
      <Typography sx={{ fontSize: '1.2rem' }}>
      Flow
      </Typography>
      <Typography sx={{ fontSize: '1.2rem' }}>
        Rate ({hydraulicsUnit?.flow_in?.label})
      </Typography>
      </Box>
      ),
      flex: 1,
      hide: dialogParameter === 'rollover' || hideFlowRate || dialogParameter === 'displacement',
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 10,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderEditCell: renderValueCell,
      editable: true,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => {
        if (params.value === null || params.value === undefined || params.value === '') {
          return '';
        }
        const value = Number(params.value);
        if (isNaN(value)) {
          return params.value;
        }
        return currentUnit !== UNIT_SYSTEM.US ? value : parseFloat(value.toFixed(hydraulicsUnit?.flow_in?.decimals));
      },
    },
    {
      field: 'sbp',
      headerName: `SBP (${hydraulicsUnit?.sbp?.label})`,
      flex: 1,
      hide: false,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 50,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderEditCell: renderValueCell,
      editable: true,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => {
        if (params.value === null || params.value === undefined || params.value === '') {
          return '';
        }
        const value = Number(params.value);
        if (isNaN(value)) {
          return params.value;
        }
        return currentUnit !== UNIT_SYSTEM.US ? value : parseFloat(value.toFixed(hydraulicsUnit?.sbp?.decimals));
      },
    },
    {
      field: 'eq_losses',
      headerName: `Equipment Losses (${hydraulicsUnit?.eq_losses?.label})`,
      renderHeader: () => (
      <Box>
      <Typography sx={{ fontSize: '1.2rem' }}>
      Equipment
      </Typography>
      <Typography sx={{ fontSize: '1.2rem' }}>
        Losses ({hydraulicsUnit?.eq_losses?.label})
      </Typography>
      </Box>
      ),
      flex: 1,
      hide: !hideEQLosses,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 50,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderEditCell: renderValueCell,
      editable: true,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => {
        if (params.value === null || params.value === undefined || params.value === '') {
          return '';
        }
        const value = Number(params.value);
        if (isNaN(value)) {
          return params.value;
        }
        return currentUnit !== UNIT_SYSTEM.US ? value : parseFloat(value.toFixed(hydraulicsUnit?.eq_losses?.decimals));
      },
    },
    {
      field: 'correction_factor',
      headerName: 'Correction Factor',
      renderHeader: () => (
      <Box>
      <Typography sx={{ fontSize: '1.2rem' }}>
      Correction
      </Typography>
      <Typography sx={{ fontSize: '1.2rem' }}>
      Factor
      </Typography>
      </Box>
      ),
      flex: 1,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderEditCell: renderValueCell,
      editable: true,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => {
        if (params.value === null || params.value === undefined || params.value === '') {
          return '';
        }
        const value = Number(params.value);
        if (isNaN(value)) {
          return params.value;
        }
        return currentUnit !== UNIT_SYSTEM.US ? value : parseFloat(value.toFixed(2));
      },
    },
  ];
};
export default columns;
